/**
 * @module utils/validateUploadForm
 * @description
 *   Client-side upload form validation (mirrors server validateInput limits).
 *
 * @extracted-from client/src/App.js (lines ~598–650, Phase 7)
 */

/**
 * @param {object} params
 * @param {'music'|'book'} params.craftType
 * @param {File|null} params.selectedFile
 * @param {object} params.formData
 * @returns {string[]} error messages
 */
export function validateUploadForm({ craftType, selectedFile, formData }) {
  const errors = [];

  if (craftType === 'music') {
    if (!selectedFile) {
      errors.push('Please select an audio file');
    }

    if (!formData.trackTitle.trim()) {
      errors.push('Track title is required');
    } else if (formData.trackTitle.length > 200) {
      errors.push('Track title must be less than 200 characters');
    }

    if (!formData.artistName.trim()) {
      errors.push('Artist name is required');
    } else if (formData.artistName.length > 200) {
      errors.push('Artist name must be less than 200 characters');
    }

    if (formData.lyrics && formData.lyrics.length > 10000) {
      errors.push('Lyrics must be less than 10,000 characters');
    }

    if (!formData.genre || !formData.genre.trim()) {
      errors.push('Genre is required');
    }
  } else {
    if (!formData.bookTitle.trim()) {
      errors.push('Book title is required');
    } else if (formData.bookTitle.length > 200) {
      errors.push('Book title must be less than 200 characters');
    }

    if (!formData.authorName.trim()) {
      errors.push('Author name is required');
    } else if (formData.authorName.length > 200) {
      errors.push('Author name must be less than 200 characters');
    }

    // For books, manuscript content is optional
    if (formData.manuscript.trim() && formData.manuscript.length > 50000) {
      errors.push('Manuscript must be less than 50,000 characters');
    }

    if (!formData.genre.trim()) {
      errors.push('Genre is required');
    }

    if (!formData.targetAudience.trim()) {
      errors.push('Target audience is required');
    }
  }

  return errors;
}
